import { tokens as tokens$1 } from '@equinor/eds-tokens';

var _tokens$colors$ui = tokens$1.colors.ui,
  lighter = _tokens$colors$ui.background__default.rgba,
  light = _tokens$colors$ui.background__light.rgba,
  mediumColor = _tokens$colors$ui.background__medium.rgba,
  _tokens$spacings$comf = tokens$1.spacings.comfortable,
  spacingSmall = _tokens$spacings$comf.small,
  spacingMedium = _tokens$spacings$comf.medium;
var divider = {
  lighter: {
    background: lighter
  },
  light: {
    background: light
  },
  mediumColor: {
    background: mediumColor
  }
};
var small = {
  spacings: {
    top: spacingSmall,
    bottom: spacingSmall
  }
};
var medium = {
  spacings: {
    top: spacingMedium,
    bottom: spacingMedium
  }
};

export { divider, medium, small };
